<template>
    <div class="trial-banner">
        <div class="trial-banner__left">
            <div class="trial-banner__text">
                {{ $t('trialNotice.youUseFree') }}
            </div>
            <!-- @TODO CURRENCY HERE? -->
            <div
                class="trial-banner__subtext"
                v-html="
                    $t('trialNotice.text', {
                        price: $i18n.locale === 'rus' ? 20 : 0.79,
                        currency: 'рублей',
                    })
                "
            ></div>
        </div>
        <div class="trial-banner__right">
            <button
                class="trial-banner__button button button--big"
                type="button"
                @click="$emit('click', $event)"
            >
                {{ $t('trialNotice.voice') }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TrialBanner',
    emits: ['click'],
};
</script>

<style lang="scss" src="./TrialBanner.scss"></style>
